import header from './atoms/header'
import carouselManager from './home/tns-carousel'

header()
carouselManager()
